if(window.location.href.includes("collections/")){
    var str = window.location.href;
    var n = window.location.href.lastIndexOf('/');


    var pageSlug = str.substring(n + 1);
    if(!pageSlug.includes("#")) //do not handle jumps to sections
    {
        setCookie('activeCategory', pageSlug, 7);
    }


    var pageName = document.getElementById("pageTitle").innerHTML;
    setCookie('activeCategoryName', pageName, 7);
}

if(window.location.href.includes("pages/contact")) //only execute for contact page
{
    var redirectLinkCategoryNotSet = document.getElementById("redirect-link-event-not-set");
    var redirectLinkCategorySet = document.getElementById("redirect-link-event-set");


    var activeCategory = getCookie('activeCategory');
    var activeEventName = getCookie('activeCategoryName');

    if(activeCategory != ""){
        redirectLinkCategoryNotSet.style = "display: none";
        redirectLinkCategorySet.style = "display: block";
        redirectLinkCategorySet.href="../collections/"+activeCategory+"/#multicolumn";
    }
    else{
        redirectLinkCategoryNotSet.style = "display: block";
        redirectLinkCategorySet.style = "display: none";
    }
}

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

var activeCategory = getCookie('activeCategory');
var activeEventName = getCookie('activeCategoryName');

if(activeCategory != ""){

    if(window.location.href.indexOf("/en") != -1){
        var rootString = "/en/collections/" + activeCategory;
    }
    else{
        var rootString = "/collections/" + activeCategory;
    }

    var logoLink = document.getElementById('navLogoMain');
    logoLink.href = rootString;

    var announcementLink = document.getElementById('announcementLink');
    announcementLink.href = rootString;

    var productsLink = document.getElementById('productsLink');
    productsLink.href = rootString;

    var eventNameAnnouncement = document.getElementById('eventNameAnnouncement');
    eventNameAnnouncement.innerHTML = activeEventName;

    if(document.getElementById("cartProductLink")){
        var cartProductLink = document.getElementById('cartProductLink');
        cartProductLink.href = rootString;
    }

    if(document.getElementById("cartProductTitleLink")){
        var cartProductTitleLink = document.getElementById('cartProductTitleLink');
        cartProductTitleLink.href = rootString;
    }
    if(document.getElementById("continueShoppingButton")){
        var continueShoppingButton = document.getElementById('continueShoppingButton');
        continueShoppingButton.href = rootString;
    }

}

if(window.location.href.includes("cart")) //for setting the event in the cart, for additional order handling (receipt,...)
{
    document.getElementById("eventName").value = activeEventName;

    //have to check if event is set, if not -> redirect do event selection page
    if(activeEventName.length === 0 || activeEventName == null){
        if(window.location.href.indexOf("/en") != -1){
            window.location.href = '/en/collections';
        }
        else{
            window.location.href = '/collections';
        }
    }
    setCustomCartInputs();

    document.querySelectorAll(".cart-text-input").forEach(function(element) {
        element.addEventListener("change", function(e) {
            setCustomCartInputs();
        });
    });
}

function setCustomCartInputs(){
    if(window.location.href.indexOf("/en") !== -1){
        document.getElementById("Cart-note").value = "Event: " + document.getElementById("eventName").value +
            " |break| Stand name: " + document.getElementById("standName").value +
            " |break| Stand number: " + document.getElementById("standNumber").value +
            " |break| PO number: " + document.getElementById("poNumber").value;
    }
    else{
        document.getElementById("Cart-note").value = "Event: " + document.getElementById("eventName").value +
            " |break| Standname: " + document.getElementById("standName").value +
            " |break| Standnummer: " + document.getElementById("standNumber").value +
            " |break| PO-Nummer: " + document.getElementById("poNumber").value;
    }
    //console.log("cart-note: " + document.getElementById("Cart-note").value);
}
